import React, { useState } from 'react';
import styled from 'styled-components';
import { colors, helpers, sizes } from 'styles/variables';
import RichText from 'utils/RichText';

export default props => {
	const lang = props.pageContext.lang || '';
	const [faq] = useState(require(`data/${lang}_faq`));

	const Wrapper = styled.div`
		display: grid;
		grid-gap: ${sizes[2]};
		grid-auto-flow: row;
		strong {
			display: inline;
		}
	`;
	const Item = styled.div`
		background: ${colors.background[0]};
		${helpers.shadow};
		border-radius: ${sizes[0]};
	`;
	const Q = styled.div`
		font-weight: bold;
		font-size: 1.2rem;
		padding: ${sizes[2]};
		padding-bottom: ${sizes[1]};
	`;
	const A = styled.div`
		padding: ${sizes[2]};
		padding-top: 0;
		font-size: 0.9rem;
		color: ${colors.foreground[2]};
		a {
			display: inline-block;
			text-decoration: underline;
		}
	`;
	return (
		<>
			<Wrapper>
				{faq.map(
					(item, index) =>
						item.answer_app && (
							<Item key={index}>
								<Q>{item.question}</Q>
								<A>
									<RichText data={item.answer_app} />
								</A>
							</Item>
						),
				)}
			</Wrapper>
		</>
	);
};
